import _createClass from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { cookies } from "@catchoftheday/utilities";

var CustomerPayload = /*#__PURE__*/_createClass(function CustomerPayload(id) {
  _classCallCheck(this, CustomerPayload);

  _defineProperty(this, "id", void 0);

  this.id = id;
});

export var PageViewPayload = /*#__PURE__*/_createClass( // Base props
// Product context
// Event context
// Shop context
function PageViewPayload(_ref) {
  var salesChannel = _ref.salesChannel,
      customerUuid = _ref.customerUuid,
      pageType = _ref.pageType,
      productId = _ref.productId,
      offerId = _ref.offerId,
      shopId = _ref.shopId,
      eventId = _ref.eventId;

  _classCallCheck(this, PageViewPayload);

  _defineProperty(this, "time", void 0);

  _defineProperty(this, "salesChannel", void 0);

  _defineProperty(this, "url", void 0);

  _defineProperty(this, "pageType", void 0);

  _defineProperty(this, "duuid", void 0);

  _defineProperty(this, "customer", void 0);

  _defineProperty(this, "productId", void 0);

  _defineProperty(this, "offerId", void 0);

  _defineProperty(this, "seid", void 0);

  _defineProperty(this, "eventId", void 0);

  _defineProperty(this, "shopId", void 0);

  this.time = parseInt("".concat(Date.now() / 1000));
  this.salesChannel = salesChannel;
  this.pageType = pageType;
  this.url = typeof location !== "undefined" ? location.href.replace(location.search, "") : "";
  this.duuid = cookies.get("did");
  this.customer = customerUuid ? new CustomerPayload(customerUuid) : undefined;
  this.productId = productId;
  this.offerId = offerId;
  this.shopId = shopId;
  this.eventId = eventId;

  if (productId) {
    this.seid = -1;
  }
});